import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { serverInfo } from "../../../../../../App";
import EventImg from "../../../../../../Assets/Images/Football.jpg";
const AllFollowUnFollowStar = () => {

  const { imageCdnUrl } = useContext(serverInfo);


  const [followingCat, setStarCategory] = useState([]);
  const [followingStarCat, setFollowStarCategory] = useState([]);

  const [buffer, setBuffer] = useState(true);
  const [followersIds, setFollowersIds] = useState([]);
  useEffect(() => {
    // const cat_slug = props.match.params.slug;

    axios.get(`/api/user/selected/starcategory`).then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setStarCategory(res.data.allSuperstar);
        setFollowStarCategory(res.data.followStarCategory);
        setFollowersIds(res.data.followingStarCategory);
      }
    });
  }, []);

  function handleFollowing(id) {
    if (!(followingStarCat?.includes(id))) {
      setFollowStarCategory([...followingStarCat, id]);
      handleChange(id);
    }

    if (followingStarCat?.includes(id)) {
      const checked_data = followingStarCat.filter((item) => item !== id);
      setFollowStarCategory(checked_data);
      handleChange(id);
    }
  }

  function handleChange(data) {
    const formData = new FormData();

    formData.append("star_id", data);
    axios
      .post(`/api/user/selected/starcategory/store`, formData)
      .then((res) => {
        setFollowersIds(res.data.followers);

        if (res.status === 200) {
          toast.success("Followers list updated", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }

  return (
    <>
      <ToastContainer theme="dark" />
      <div className="col-md-12  ">
        <h2 className="mb-3 text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
          Follower List
        </h2>
        {buffer && (
          <center>
            <div class="spinner-border text-warning" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </center>
        )}

        <div className="row">
          {followingCat.map((user) => (
            <>
              {followersIds?.includes(user?.super_star?.id) && (
                <div className="containerSa col-sm-12 col-md-4 col-lg-3 mb-3">
                  <div className="card follow-card">
                    <img
                      src={imageCdnUrl + user?.super_star?.image}
                      className="ImgCat"
                      alt={EventImg}
                      height="220px"
                    />
                    <Link to={`/starprofile/${user.super_star?.id}`} className="text-light">
                    <div className="FollowingCatText fw-bold p-2 limit">
                      {user?.super_star?.first_name}{" "}
                      {user?.super_star?.last_name}
                    </div>
                    </Link>

                    <button
                      className="CatBgS "
                      onClick={() => {
                        handleFollowing(user?.super_star?.id);
                      }}
                    >
                      {followingStarCat?.includes(user?.super_star?.id)
                        ? "✅ Following"
                        : "➕ Follow"}
                    </button>
                  </div>
                </div>
              )}
            </>
          ))}
        </div>
      </div>

      {/* Suggested List */}

      {/* <>
        {!followersIds.includes.length === 0 ? (
          <div className="text-light">Null</div>
        ) : (
          <div className="text-light">Show</div>
        )}
      </> */}

      <div className="col-md-12  ">
        <h2 className="mb-3 mt-4 text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
          Suggested List
        </h2>
        {buffer && (
          <center>
            <div class="spinner-border text-warning" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </center>
        )}

        <div className="row">
          {followingCat.map((user) => (
            <>
              {!(followersIds?.includes(user?.super_star?.id)) && (
                <div className="containerSa col-sm-12 col-md-4 col-lg-3 mb-3">
                  <div className="card follow-card">
                    <img
                      src={imageCdnUrl + user?.super_star?.image}
                      className="ImgCat"
                      alt={EventImg}
                      height="220px"
                    />
                    <Link to={`/starprofile/${user.super_star?.id}`} className="text-light">
                    <div className="FollowingCatText fw-bold p-2 limit">
                      {user?.super_star?.first_name}{" "}
                      {user?.super_star?.last_name}
                    </div>
                    </Link>
                    <button
                      className="CatBgS "
                      onClick={() => {
                        handleFollowing(user?.super_star?.id);
                      }}
                    >
                      {followingStarCat?.includes(user?.super_star?.id)
                        ? "✅ Following"
                        : "➕ Follow"}
                    </button>
                  </div>
                </div>
              )}
            </>
          ))}
        </div>
      </div>
    </>
  );
};

export default AllFollowUnFollowStar;
